import React from 'react';
import Image from 'next/image';

type Props = {
    serviceName: string;
    serviceDescription: any;
    serviceDescriptiontwo?: any;
    path: any;
    alt: string;
    title: string;
    width: number;
    height: number;
};

const SubServices: React.FC<Props> = ({
    serviceName,
    serviceDescription,
    path,
    alt,
    title,
    width,
    height,
    serviceDescriptiontwo,
}) => {
    return (
        <div
            className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="300"
        >
            <div className="card-body">
                <Image src={`${path}`} width={width} height={height} alt={alt} title={title} className="img-fluid mb-5" loading="lazy" />
                <h3 className="card-title fs-lg fw-700 mb-5 text-textcolor">{serviceName}</h3>
                <p className="card-text fs-md fw-400 text-secondary mb-0">{serviceDescription}</p>
                <p className="card-text fs-md fw-400 text-secondary mt-2">{serviceDescriptiontwo}</p>
            </div>
        </div>
    );
};

export default SubServices;
